module.exports = __webpack_public_path__ + "img/fang.0bcebb76.svg";